module.exports = __webpack_public_path__ + "static/media/search-icon.4495e7d1.svg";